import { render, staticRenderFns } from "./TagPreferencesDialog.vue?vue&type=template&id=5211c966&scoped=true&"
import script from "./TagPreferencesDialog.vue?vue&type=script&lang=js&"
export * from "./TagPreferencesDialog.vue?vue&type=script&lang=js&"
import style0 from "./TagPreferencesDialog.vue?vue&type=style&index=0&id=5211c966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5211c966",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VImg,VRow})
